import {
  AnimatedButtonContainer,
  AnimatedButtonRow,
  Button,
} from "@babackapp/customer-ui/components/button";
import {
  Header,
  HeaderDescription,
  HeaderTitle,
} from "@babackapp/customer-ui/components/header";
import { Label } from "@babackapp/customer-ui/components/label";
import {
  Option,
  OptionAction,
  OptionDescription,
  OptionIcon,
  OptionsList,
  OptionTitle,
} from "@babackapp/customer-ui/components/option";
import { RadioGroup, RadioGroupItem } from "@babackapp/customer-ui/components/radio-group";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import { EnterIcon } from "@radix-ui/react-icons";
import { BanknoteIcon, TagIcon } from "lucide-react";
import { Controller } from "react-hook-form";
import { useShopNowRemainingCredit } from "../hooks/use-shop-now-remaining-credit";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";

export function ShopNowRemainingCreditPage() {
  const { form, forcedMethod, hasDiscountEnabled, formattedRemaining, handleConfirm } =
    useShopNowRemainingCredit();
  const t = useCustomText();

  if (forcedMethod) {
    return (
      <WidgetPage>
        <Header>
          <HeaderTitle>{t("remainingCredit.title")}</HeaderTitle>
          <HeaderDescription>
            {forcedMethod === "discount"
              ? t("remainingCredit.forcedDiscount", { amount: formattedRemaining })
              : t("remainingCredit.forcedRefund", { amount: formattedRemaining })}
          </HeaderDescription>
        </Header>
        <AnimatedButtonRow variants={{}}>
          <AnimatedButtonContainer layoutId="line-item-confirm-button" variants={{}}>
            <Button onClick={handleConfirm}>
              <EnterIcon />
              {t("common.continue")}
            </Button>
          </AnimatedButtonContainer>
        </AnimatedButtonRow>
      </WidgetPage>
    );
  }

  return (
    <WidgetPage>
      <Header>
        <HeaderTitle>{t("remainingCredit.title")}</HeaderTitle>
        <HeaderDescription>
          {t("remainingCredit.description", { amount: formattedRemaining })}
        </HeaderDescription>
      </Header>

      <Controller
        control={form.control}
        name="method"
        render={({ field }) => (
          <RadioGroup
            value={field.value}
            onValueChange={field.onChange}
            className="w-full mt-4"
          >
            {hasDiscountEnabled && (
              <Label htmlFor="remaining-discount">
                <OptionsList>
                  <Option>
                    <OptionIcon><TagIcon /></OptionIcon>
                    <OptionTitle>{t("financial.discount")}</OptionTitle>
                    <OptionDescription>
                      {t("remainingCredit.discount.description", { amount: formattedRemaining })}
                    </OptionDescription>
                    <OptionAction>
                      <RadioGroupItem value="discount" id="remaining-discount" />
                    </OptionAction>
                  </Option>
                </OptionsList>
              </Label>
            )}
            <Label htmlFor="remaining-refund">
              <OptionsList>
                <Option>
                  <OptionIcon><BanknoteIcon /></OptionIcon>
                  <OptionTitle>{t("financial.refund")}</OptionTitle>
                  <OptionDescription>
                    {t("remainingCredit.refund.description", { amount: formattedRemaining })}
                  </OptionDescription>
                  <OptionAction>
                    <RadioGroupItem value="refund" id="remaining-refund" />
                  </OptionAction>
                </Option>
              </OptionsList>
            </Label>
          </RadioGroup>
        )}
      />

      <AnimatedButtonRow variants={{}}>
        <AnimatedButtonContainer layoutId="line-item-confirm-button" variants={{}}>
          <Button onClick={handleConfirm}>
            <EnterIcon />
            {t("common.confirm")}
          </Button>
        </AnimatedButtonContainer>
      </AnimatedButtonRow>
    </WidgetPage>
  );
}
